var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ty-label weui-cells",class:{fix:_vm.fixed,top:_vm.fixed=='top',bottom:_vm.fixed=='bottom'},style:({height:_vm.height+'px','line-height':_vm.height+'px','text-align':_vm.textAlign})},[_c('p',{staticClass:"weui-cells__tips",style:({'text-align':_vm.textAlign}),domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-839467f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ty-label/TyLabel.vue
// module id = 342
// module chunks = 0